import { useState, useEffect } from "react";
import { ASSET_SEVERITIES } from "../../../common/constants";
import { getLocale, history } from "../../../common/helpers";
import alarmIcon from "../icons/alarm_white.png";
import alertIcon from "../icons/alert_white.png";
import {
  ALERT_DESC_HEADER,
  FORMAT_DATE,
  NOTIFICATION_UNITS,
  ROUND_OFF_VALUE,
  SEVERITY_COLOR,
  ALARM_SETTINGS,
} from "./constants";
import { NotificationTileWrapper } from "./styles";
import { useTranslation } from "react-i18next";

const NotificationTile = (props) => {
  const { t } = useTranslation();
  const {
    adminDesc,
    alarmDesc,
    alarmId,
    alarmType,
    alarmTypeId,
    alertDesc,
    alertType,
    assetHierarchyDesc,
    categoryId,
    channelType,
    createdDate,
    high,
    isRead,
    low,
    measUnitId,
    notificationId,
    severityId,
    triggeredValue,
  } = props.data;

  const { isSuccess } = props;

  const severity =
    ASSET_SEVERITIES.find((x) => x.severityId === severityId) ?? undefined;

  const color = SEVERITY_COLOR(severity.adminDesc);

  const language = getLocale(window.location.pathname, true);

  const severityStyle = {
    backgroundColor: color.backgroundColor,
    border: `1px solid ${color.borderColor}`,
  };

  const alarmSettings = alarmTypeId
    ? ALARM_SETTINGS.find((x) => x.alarmTypeId === alarmTypeId.toUpperCase())
    : "";

  const getNotificationUnit = () => {
    if (alarmType === 5 || alarmType === 6) {
      return NOTIFICATION_UNITS.find((data) => data.unitId === measUnitId)
        .value;
    } else {
      return alarmTypeId
        ? NOTIFICATION_UNITS.find(
            (data) =>
              data.alarmTypeId === alarmTypeId.toUpperCase() ||
              data.unitId === measUnitId
          ).value
        : "";
    }
  };

  const notificationUnit = getNotificationUnit();

  const getRoundOffValue = () => {
    if (alarmType === 5 || alarmType === 6) {
      return triggeredValue.toFixed(3);
    } else {
      return alarmTypeId ? ROUND_OFF_VALUE(alarmTypeId, triggeredValue) : null;
    }
  };

  const roundOffValue = getRoundOffValue();

  const formattedTriggeredValue = roundOffValue + " " + notificationUnit;

  const alertDescHeader = ALERT_DESC_HEADER(
    alarmType,
    low,
    high,
    notificationUnit
  );

  const getAlarmTitle = () => {
    if (alarmType === 5) {
      return "Vibration Level Change Alarm";
    } else if (alarmType === 6) {
      return adminDesc;
    } else {
      return alarmType
        ? alarmSettings.settings.find((data) => data.alarmType === alarmType)
            .value +
            " " +
            alertDescHeader
        : "";
    }
  };

  const alarmTitle = getAlarmTitle();

  const formattedDateTime = FORMAT_DATE(createdDate);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxClick = (data) => {
    setIsChecked((isChecked) => !isChecked);

    // If checkbox is checked, call the callback function to add data
    if (!isChecked) {
      props.addNotification(data);

      props.setIsSuccess(true);
    }
    // If checkbox is unchecked, call the callback function to remove data
    else {
      props.removeNotification(data);
    }
  };

  useEffect(() => {
    if (!isSuccess) {
      setIsChecked(false);
    }
    return () => {};
  }, [isSuccess]);

  const machineCategory = JSON.parse(localStorage.getItem("machineCategory"));

  let machineName = machineCategory
    ? machineCategory.map((item) => {
        if (categoryId === item.categoryId) return item.name;
        return null;
      })
    : "";

  return (
    <NotificationTileWrapper>
      {!(alarmDesc || alarmId || alarmType || alarmTypeId) ? (
        <div className="notification-list">
          <div
            className="notification-list-header"
            style={{
              backgroundColor: isRead ? "gray" : "#e25153",
            }}
          >
            <input
              checked={isChecked || props.selectAll}
              onChange={() => {
                handleCheckboxClick(notificationId);
              }}
              type="checkbox"
              value={isChecked || props.selectAll || ""}
            />
            {alertType ? <img src={alertIcon} alt="alertIcon" loading="lazy" width="20" height="20" /> : ""}
            <span>{adminDesc}</span>
          </div>
          <div className="notification-list-header-icon"></div>
          <div
            onClick={() => {
              history.push(language + "/team");
              props.closePopup();
            }}
            className="notification-list-body"
          >
            {alertDesc}
          </div>
          <div className="notification-list-footer">{formattedDateTime}</div>
        </div>
      ) : (
        <div className="notification-list">
          <div
            style={{ backgroundColor: isRead ? "gray" : "#e25153" }}
            className="notification-list-header"
          >
            <input
              checked={isChecked || props.selectAll}
              onChange={() => {
                handleCheckboxClick(notificationId);
              }}
              type="checkbox"
              value={isChecked || props.selectAll || ""}
            />
            <img src={alarmIcon} alt="alarmIcon" loading="lazy" width="20" height="20" />
            <span>{alarmTitle}</span>
          </div>
          <div className="notification-list-body margin5">
            <div style={severityStyle} className="chip">
              {severity.adminDesc}
            </div>
            {channelType && <div className="channel-type">{channelType}</div>}
            <div>
              <div className="temperature">{formattedTriggeredValue}</div>
              <div className="notification-list-footer padding0">
                {formattedDateTime}
              </div>
            </div>
          </div>
          <hr />
          <div className="footer">
            <div>
              {t("Asset/Test Point")}
            </div>
            <div>{assetHierarchyDesc}</div>
          </div>
          {alarmType === 5 && (
            <>
              <hr />
              <div className="footer">
                <div>
                  {t("Machine Category")}
                </div>
                <div>{machineName}</div>
              </div>
            </>
          )}
        </div>
      )}
    </NotificationTileWrapper>
  );
};

export default NotificationTile;
